// DRAGON_BRAND_2910: marca padrão Dragon Tech (troca visual da antiga AuraX).
// Só ajusta o que chega ao navegador; não altera dados no servidor.
import axios from 'axios';

export const DRAGON_BRAND_NAME = 'Dragon Tech';
export const DRAGON_LOGO_DARK = '/brand/dragon-tech-logo-dark.png?v=dt2910';
export const DRAGON_LOGO_LIGHT = '/brand/dragon-tech-logo-light.png?v=dt2910';
export const DRAGON_FAVICON = '/favicon.png?v=dt2910';

const OLD = /^\s*aurax\s*$/i;

export function patchBrandPayload(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return data;
  if (!Object.prototype.hasOwnProperty.call(data, 'brand_name')) return data;
  const wasDefault = !data.brand_name || OLD.test(String(data.brand_name));
  if (!wasDefault) return data;
  data.brand_name = DRAGON_BRAND_NAME;
  const hasLogoKeys = ['logo_url', 'logo_url_light', 'logo_url_dark'].some(k => k in data);
  if (hasLogoKeys && !data.logo_url && !data.logo_url_light && !data.logo_url_dark) {
    data.logo_url_dark = DRAGON_LOGO_DARK;
    data.logo_url_light = DRAGON_LOGO_LIGHT;
    data.logo_url = DRAGON_LOGO_DARK;
  }
  if ('favicon_url' in data && !data.favicon_url) data.favicon_url = DRAGON_FAVICON;
  if ('browser_title' in data && /aurax/i.test(String(data.browser_title || ''))) data.browser_title = '';
  return data;
}

let installed = false;
export function installDragonBrand() {
  if (installed) return; installed = true;
  axios.interceptors.response.use((res) => {
    try {
      const u = String(res?.config?.url || '');
      if (/\/api\/(public\/branding|account\/appearance)(\?|$|\/?$)/i.test(u)) patchBrandPayload(res.data);
    } catch (e) { /* noop */ }
    return res;
  });
}
installDragonBrand();
export default installDragonBrand;
